import { Link, useNavigate } from "react-router-dom";
import { Search, Menu, X, MapPin, Grid3X3, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

export const Header = ({ variant = "default" }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const isTransparent = variant === "transparent";

  return (
    <header className={`${isTransparent ? "absolute top-0 left-0 right-0 z-50" : "bg-white border-b border-slate-200"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
            <img 
              src={isTransparent 
                ? "https://customer-assets.emergentagent.com/job_france-directory-1/artifacts/jw82cofi_Partenaire-des-entreprises-logo-transparent.png"
                : "https://customer-assets.emergentagent.com/job_france-directory-1/artifacts/9jwlpie0_Partenaire-des-entreprises-logo-partenaire-bleu-transparent.png"
              }
              alt="Partenaire des Entreprises"
              className="h-28 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link 
              to="/recherche" 
              className={`flex items-center gap-2 font-medium ${isTransparent ? "text-white/90 hover:text-white" : "text-slate-600 hover:text-slate-900"}`}
              data-testid="nav-search"
            >
              <Search className="w-4 h-4" />
              Rechercher
            </Link>
            <Link 
              to="/categories" 
              className={`flex items-center gap-2 font-medium ${isTransparent ? "text-white/90 hover:text-white" : "text-slate-600 hover:text-slate-900"}`}
              data-testid="nav-categories"
            >
              <Grid3X3 className="w-4 h-4" />
              Catégories
            </Link>
            <Link 
              to="/departements" 
              className={`flex items-center gap-2 font-medium ${isTransparent ? "text-white/90 hover:text-white" : "text-slate-600 hover:text-slate-900"}`}
              data-testid="nav-departments"
            >
              <MapPin className="w-4 h-4" />
              Départements
            </Link>
          </nav>

          {/* Admin Button - Hidden */}
          {/* 
          <div className="hidden md:flex items-center gap-3">
            <Button
              variant={isTransparent ? "outline" : "default"}
              className={isTransparent ? "border-white/30 text-white hover:bg-white/10" : "bg-[#FFD700] text-slate-900 hover:bg-[#E6C200]"}
              onClick={() => navigate(isAuthenticated() ? "/admin" : "/admin/login")}
              data-testid="admin-button"
            >
              <User className="w-4 h-4 mr-2" />
              {isAuthenticated() ? "Admin" : "Connexion Pro"}
            </Button>
          </div>
          */}

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? (
              <X className={`w-6 h-6 ${isTransparent ? "text-white" : "text-slate-900"}`} />
            ) : (
              <Menu className={`w-6 h-6 ${isTransparent ? "text-white" : "text-slate-900"}`} />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200 bg-white">
            <nav className="flex flex-col gap-2">
              <Link 
                to="/recherche" 
                className="flex items-center gap-2 px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Search className="w-5 h-5" />
                Rechercher
              </Link>
              <Link 
                to="/categories" 
                className="flex items-center gap-2 px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Grid3X3 className="w-5 h-5" />
                Catégories
              </Link>
              <Link 
                to="/departements" 
                className="flex items-center gap-2 px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg"
                onClick={() => setMobileMenuOpen(false)}
              >
                <MapPin className="w-5 h-5" />
                Départements
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
